import { htmlElem } from '../utils/globals';

const activeClass = 'active';

const activeNavigation = () => {
    const navElem = htmlElem.querySelector('header nav');
    const navItems = navElem.querySelectorAll('li a');
    if (navItems.length) {
        [...navItems].forEach(item => item.classList.remove(activeClass));
        const arrPaths = document.location.pathname.split('/');
        const primaryDir = arrPaths[1];
        const activeItem = navElem.querySelector(`a[href^='/${primaryDir}']`);
        if (activeItem) {
            activeItem.className = activeClass;
        }
    }
}

export {
    activeNavigation
}